<template>
	<div class="car-segment-tooltip__activator" @pointerenter="activate" @click.stop="activate">
		<GlobalIcon class="car-segment-tooltip__icon" :height="20" name="tooltip" />

		<v-menu
			v-if="hovered"
			v-model="model"
			activator="parent"
			:open-delay="50"
			:close-delay="50"
			:open-on-hover="!isMobile_lg"
			scroll-strategy="close"
			:offset="16"
			location="bottom center"
			class="car-segment-tooltip">
			<div class="car-segment-tooltip__dropdown">
				<div class="car-segment-tooltip__title">
					{{ i18nService.$tDynamic('pages.panel.discount_codes.code_id.segments', segmentsMapTranslations[segment]) }}
				</div>
				<div v-if="cars" class="car-segment-tooltip__cars">
					<div v-for="(car, i) in cars" :key="i" class="car-segment-tooltip__car">
						<div class="car-segment-tooltip__car-title">{{ car.brand }} {{ car.name }}</div>
						<div v-if="car.image" class="car-segment-tooltip__car-img-container">
							<GlobalImage class="car-segment-tooltip__car-img" :src="car.image" :alt="car.fullName" :width="120" sizes="xs:120px" />
						</div>
					</div>
				</div>
				<div v-else class="car-segment-tooltip__loader-container">
					<v-progress-circular aria-label="loading" class="car-segment-tooltip__loader" color="var(--primary-color)"></v-progress-circular>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script setup lang="ts">
const { isMobile_lg } = useWindowWidth()
const i18nService = usei18nService()

const prop = defineProps<{
	segment?: string
	segmentID?: number
}>()

const model = defineModel<boolean>()
const hovered = ref(false)

const activate = () => {
	hovered.value = true
}

// On first mount of v-menu, open immediately — Vuetify hasn't attached listeners yet
watch(
	hovered,
	() => {
		nextTick(() => {
			model.value = true
		})
	},
	{ once: true },
)

const carsStore = useCarsStore()
const cars = ref<IProductModel[]>()

const getCars = async () => {
	if (!prop.segmentID) return
	try {
		cars.value = await carsStore.fetchSegmentCars(prop.segmentID)
	} catch (err) {
		logger.error(err)
	}
}

watch(
	() => model.value,
	async () => {
		if (model.value && !cars.value) {
			await getCars()
		}
	},
)
</script>

<style lang="scss" scoped src="./SegmentTooltip.scss"></style>
